import * as React from "react"
import { SprocketAsset } from "../../../types/types";

type Props = {
  image: SprocketAsset
}
export default (props: Props) : JSX.Element => (
  <>
    <div className='zoover__content'>
      <h2>{I18n.t('zoover.title')}</h2>
      <p>{I18n.t('zoover.content')}</p>
    </div>
    <div className='zoover__image'>
      <img className="zoover__img" src={props.image.url} alt="Gites zoover award 2018" />
    </div>
  </>
)
